<div class="search-field">
  <div class="input-group">
    <input
      class="form-control"
      [name]="nomeCampo"
      [ngModel]="termo"
      (ngModelChange)="alterarTermo($event)"
      [placeholder]="placeholder">
    <button
      type="button"
      class="btn btn-outline-secondary btn-limpar-busca"
      (click)="limparTermo()"
      aria-label="Limpar pesquisa">
      <i class="bi bi-x-lg"></i>
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="buscar.emit()" [attr.aria-label]="rotuloBuscar">
      <i class="bi bi-search"></i>
    </button>
  </div>
  <div *ngIf="itens.length > 0" class="search-results">
    <button type="button" *ngFor="let item of itens" (click)="selecionar.emit(item)">
      <strong>{{ rotuloItem(item) }}</strong>
      <span *ngIf="detalheItem(item)">{{ detalheItem(item) }}</span>
    </button>
  </div>
</div>
